import { useRef, useState } from "react";
import "./index.css";
import { cn } from "./cn";
import etobleh from "../public/etobleh.webp";

export function Home() {
  const [terminalVisible, setTerminalVisible] = useState(true);
  const timeoutRef = useRef<number>(undefined);

  const handleClose = () => {
    setTerminalVisible(false);
    timeoutRef.current = window.setTimeout(() => {
      setTerminalVisible(true);
    }, 3000);
  };

  const handleShow = () => {
    clearTimeout(timeoutRef.current);
    setTerminalVisible(true);
  };

  return (
    <div className="max-w-4xl w-full h-full max-h-148 relative">
      <main
        className={cn(
          "w-full h-full bg-black border-2 border-red-50 border-t-16 font-mono p-2 selection:bg-white selection:text-black  tracking-tight leading-snug corner-squircle rounded-md",
          !terminalVisible && "hidden pointer-events-none",
        )}
      >
        <pre className="flex flex-col h-full overflow-auto">
          <Prompt>
            <span>./bas.sh</span>
            <br />
            <Links />
          </Prompt>
          <br />
          <Prompt>
            <Cursor />
          </Prompt>
        </pre>
        <button
          className="absolute -top-0.75 right-0.75 text-black select-none"
          name="Close"
          title="Close the terminal"
          onClick={handleClose}
        >
          ×
        </button>
      </main>

      <img
        src={etobleh}
        title="eto... blehhhh (click to reopen terminal)"
        alt={`A screencap of Yoriko Nikaido from the anime series "You're Under Arrest" putting her hands on her head while sticking her tongue out while saying "Ah, eto... bleh" ("Ah, well... bleh").`}
        className={cn(
          "absolute inset-0 place-self-center max-w-1/2 max-h-1/2 select-none",
          terminalVisible && "hidden",
        )}
        decoding="async"
        role="button"
        onClick={handleShow}
      />
    </div>
  );
}

function Prompt({ children }: { children?: React.ReactNode }) {
  return (
    <>
      <span className="text-cyan-200 font-bold">~</span>
      <span>
        <span className="text-purple-400">❯&nbsp;</span>
        {children}
      </span>
    </>
  );
}

function Cursor() {
  return <span className="bg-white animate-blink"> </span>;
}

function About() {
  return <>hi! i'm Bas :3</>;
}

function Links() {
  return (
    <>
      links:
      <ul>
        <li>
          <Link href="https://github.com/brw">github</Link>: <Username>brw</Username>
        </li>
        <li>
          <Link href="https://tangled.org/bas.sh">tangled</Link>: <Username>bas.sh</Username>
        </li>
        <li>
          <Link href="https://bsky.app/profile/bas.sh">bluesky</Link>: <Username>bas.sh</Username>
        </li>
        <li>
          <Site>discord</Site>: <Username>bas</Username>
        </li>
        <li>
          <Site>signal</Site>: <Username>bas.01</Username>
        </li>
      </ul>
    </>
  );
}

function Link({ href, children }: { href: string; children: React.ReactNode }) {
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener"
      className="text-blue-400 hover:text-blue-500 underline decoration-1 underline-offset-2 font-bold"
    >
      {children}
    </a>
  );
}

function Username({ children }: { children?: React.ReactNode }) {
  const copyOnClick = (e: React.MouseEvent<HTMLSpanElement>) => {
    e.preventDefault();
    navigator.clipboard.writeText(children as string);
  };

  return (
    <span className="select-all cursor-copy" title="Click to copy" onClick={copyOnClick}>
      {children}
    </span>
  );
}

function Site({ children }: { children?: React.ReactNode }) {
  return <span className="text-blue-400 font-bold">{children}</span>;
}

export default Home;
